<template>
   <div class="content-wrapper">
      <section class="content-header">
         <div class="row">
            <div class="col-xs-12">
               <h1 class="pull-left">
                  <span style="color:#00a65a">Flex365.TV</span> PIN Reports
               </h1>
               <div class="pull-right">
                  <a href="#" @click="downloadNow" class="btn" style="background-color: #526883; color: white;"><i class="fa fa-download"></i> Download Filtered</a>
                  &nbsp;
                  <a href="#" class="btn" style="background-color: #526883; color: white; display: none;"><i class="fa fa-cloud-download" style="font-size: 16px;"></i> Download All</a>
               </div>
            </div>
         </div>
      </section>
      <section class="content">
         <form v-on:submit.prevent="searchReportData">
         <div class="row">
            <div class="col-xs-6 col-sm-2">
               <div class="form-group">
                  <filterDropdownOptions />
               </div>
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <input placeholder="From" type="text" value="" name="starttime" id="starttime" v-model="starttime" autocomplete="off" class="form-control input-sm datePicker">
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <input placeholder="To" type="text" value="" name="stoptime" id="stoptime" v-model="stoptime" class="form-control input-sm datePicker" autocomplete="off">
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <select title="" name="type" id="type" v-model="type" v-select="type" class="form-control input-sm select2" @change="searchReportData">
                  <option value="">Select Type</option>
                  <option value="1">Sell</option>
                  <option value="2">Return</option>
               </select>
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <select title="" name="id_reseller" id="id_reseller" v-model="id_reseller" v-select="id_reseller" class="form-control input-sm select2" @change="searchReportData">
                  <option value="">All Reseller</option>
                  <option v-for="(data, index) in reseller_list" :key="index" :value="index">{{data}}</option>
               </select>
            </div>
            
            <div class="col-xs-6 col-sm-2 form-group">
               <input placeholder="Search By PIN" type="text" name="login" id="login" v-model="login" class="form-control input-sm" value="">
            </div>

            <div id="btnSearch" class="col-xs-6 col-sm-2 pull-right form-group  btnLeft" style="margin-bottom: 5px">
               <button type="submit" class="btn btn-sm btn-submit pull-right">
                  <i class="fa fa-search"></i> Search
               </button>
            </div>
         </div>
         </form>
         <div class="row">
            <div class="col-md-12">
               <div class="box" id="pagination">
                  <div class="box-header">
                     <h3 class="box-title">
                        Total {{listArr.length}} Row Found
                     </h3>
                  </div>
                  <div class="box-body">
                     <div class="table-responsive">
                        <table class="table table-0024 table-bordered table-striped">
                           <thead>
                              <tr>
                                 <th class="tdCenter tdSN">SN</th>
                                 <th class="tdCenter">TV PIN</th>
                                 <th class="tdCenter">Login Date</th>
                                 <th class="tdCenter">Expiry Date</th>
                                 <th class="tdCenter">Plan</th>
                                 <th class="tdCenter">NOD</th>
                                 <th class="tdCenter">Type</th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr v-for="(data, index) in listArr" :key="data.id">
                                 <td class="tdCenter tdSN">
                                    {{parseInt(++index)}}
                                 </td>
                                 <td :class="data.type==2?' tdCenter danger':'tdCenter success'">
                                    {{com_removeHostedPinPrefix(data.username, userData.reseller4.hosted_pin_prefix, userData.reseller4.reseller_panel_type)}}
                                 </td>
                                 <td class="tdCenter  ">
                                    {{data.creationdate}}
                                 </td>
                                 <td :class="data.type==2?'tdCenter text-red':'tdCenter'">
                                    {{data.expire_date}}
                                 </td>
                                 <td :class="data.type==2?'tdCenter text-red':'tdCenter'">
                                    {{data.description}}
                                 </td>
                                 <td :class="data.type==2?'tdCenter text-red':'tdCenter'">
                                    {{data.no_of_days}}
                                 </td>
                                 <td class="tdCenter ">
                                    <span class="label label-success" v-if="data.type==1"> Sale </span>
                                    <span class="label label-danger" v-if="data.type==2"> Return </span>
                                 </td>
                             </tr>
                              <tr v-if="listArr.length==0">
                                 <td colspan="10" class="tdCenter" style="padding: 30px 0;"><b>No Records  Found</b></td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   </div>
</template>
<script>
   import filterDropdownOptions from "@/components/common/filterDropdownOptions.vue";
   import axios from 'axios'
   export default {
      name: "FlexPinSubscriptionReport",
      components: {
         filterDropdownOptions,
      },
      data() {
         return {
            listArr : [],
            userData : {},
            reseller_list : {},
            lineTotalAmount : 0,
            type : '',
            id_reseller : '',
            starttime : '',
            stoptime : '',
            is_online : '',
            login : '',
            userlevel:'',
            flexApiUrl : process.env.VUE_APP_APIFLEXURL
         }
      },
      created(){
         if(!this.com_isTVReseller()){
            this.$router.push('dashboard');
         }
         //Get User Level from user store
         var encryptedData = this.$store.getters.getUser;
         var decodedString  = this.com_DecryptString(encryptedData);
         var userData = JSON.parse(decodedString);
         this.userData = userData;
         this.userlevel = userData.user_level;
         // End

         var rootObject = this;
         loader.show();
         axios.get('get-reseller-dropdown-data').then(function (response) {
            rootObject.reseller_list = response.data.data;
         })
         .catch(function (error) {
            let alertmessage = "";
            for (var prop in error.response.data) {
               alertmessage += ' '+error.response.data[prop]
            }
            console.log(alertmessage); 
            rootObject.com_errorHandel(error);
         });

         this.filterWiseDateRangeSet();
         this.searchReportData();
      },
      methods: {

         downloadNow(){
            loader.show();
            var rootObject = this;
   
            const form = new FormData()
            form.append('type', this.type)
            form.append('fromDate', this.starttime)
            form.append('toDate', this.stoptime)
            form.append('id_reseller', this.id_reseller)
            form.append('login', this.login)
            form.append('is_online', this.is_online)
            form.append('allow_child', 1)
            form.append('download', 1)
            form.append('short_filter', $("#short_filter").val());
            form.append('idReseller', this.userData.id_reseller)
            form.append('level', this.userData.user_level)
   
            var config = {
               headers: { 'Content-Type': 'multipart/form-data' },
               responseType: 'blob',
            }
   
            axios.post(rootObject.flexApiUrl+'/reports/pin-subscription', form, config).then(function (response) {
               //console.log(response);
               const blob = new Blob([response.data], { type: 'application/csv' });
               var a = document.createElement('a');
               var url = window.URL.createObjectURL(blob);
               a.href = url;
               var prefix = 'subscription_report_'
               var file_name = prefix.concat(rootObject.getFormattedTime());
               var ext = '.csv';
               a.download = file_name.concat(ext);
               document.body.append(a);
               a.click();
               a.remove();
               window.URL.revokeObjectURL(url);
               loader.hide();
               
            })
            .catch(function (error) {
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
                }
                console.log(alertmessage);
                loader.hide();
                rootObject.com_errorHandel(error);
            });
         },


         searchReportData(){
            loader.show();
            var rootObject = this;
   
            const form = new FormData()
            form.append('type', this.type)
            form.append('fromDate', this.starttime)
            form.append('toDate', this.stoptime)
            form.append('id_reseller', this.id_reseller)
            form.append('login', this.login)
            form.append('is_online', this.is_online)
            form.append('allow_child', 1)
            form.append('short_filter', $("#short_filter").val());
            form.append('idReseller', this.userData.id_reseller)
            form.append('level', this.userData.user_level)
            
            var config = {
             headers: { 'Content-Type': 'multipart/form-data' }
            }
   
            axios.post(rootObject.flexApiUrl+'/reports/pin-subscription', form, config).then(function (response) {
               //console.log(response);
               rootObject.populateReportData(response);
            })
            .catch(function (error) {
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
                }
                console.log(alertmessage);
                loader.hide();
                rootObject.com_errorHandel(error);
            });
         },
   
         populateReportData(response){
            var rootObject = this;
            var creationdate = '';
            var no_of_days = 0;
            this.listArr = [];
      
            for (var prop in response.data.data.pinData) {
               

               if(response.data.data.pinData[prop]['type']==2){
                  response.data.data.pinData[prop]['expire_date'] = '00-00-00 00:00:00';
               }else{
                  no_of_days = response.data.data.pinData[prop]['no_of_days'];
                  creationdate = response.data.data.pinData[prop]['creationdate'];
                  if(no_of_days > 0){
                     response.data.data.pinData[prop]['expire_date'] = this.com_modifyDateTime(no_of_days, creationdate);
                  }else{
                     response.data.data.pinData[prop]['expire_date'] = "";
                  }
               }
               this.listArr.push(response.data.data.pinData[prop]);
            }
            loader.hide();
         },
   
         filterWiseDateRangeSet()
         {
            $(".datePicker").removeAttr('readonly', 'readonly'); 
            if ($("#short_filter").val()) {
               this.starttime = '';
               this.stoptime = '';
               $(".datePicker").attr('readonly', 'readonly'); 
            }else{
               var dateRangeArr = this.com_currentDateRange();
               this.starttime = dateRangeArr.startDate;
               this.stoptime = dateRangeArr.endDate;
            }
         },

         getFormattedTime() {
            var today = new Date();
            var y = today.getFullYear();
            var m = today.getMonth() + 1;
            var d = today.getDate();
            return y + "-" + m + "-" + d;
         }
         
      },
      mounted: function() {
         var rootObject = this;
         $('#starttime').datetimepicker({
            timepicker: false,
            format: 'Y-m-d'
         }).on('change', function(e){
            rootObject.starttime = $(this).val();
         });

         $('#stoptime').datetimepicker({
            timepicker: false,
            format: 'Y-m-d'
         }).on('change', function(e){
            rootObject.stoptime = $(this).val();
         });

         $("#short_filter").on('change', function(){
            rootObject.filterWiseDateRangeSet();
            rootObject.searchReportData();
         });
   
         $(".select2").select2();
      }
   };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>